import { Routes, Route } from 'react-router-dom';

import { Loader } from '../../components/Loader';

import OAuth from '../../Auth/OAuth';
import { Outer } from './Outer';

import { Home } from '../../Home';

export const Router: React.FC = () => {
	return (
		<Loader title="WebLayout/Router">
			<Routes>
				<Route element={<Outer />}>
					<Route path="/" element={<Home />} />

					<Route path="/login/" element={<OAuth />} />
					<Route path="/login/*" element={<OAuth />} />
					<Route path="/*" element={<Home />} />
				</Route>
			</Routes>
		</Loader>
	);
};
